// export const REACT_APP_BASE_URL="https://flexiva-api.onrender.com"
export const REACT_APP_BASE_URL="https://flexivas.com/"
// export const REACT_APP_BASE_URL="http://127.0.0.1:3500"